export default __webpack_public_path__ + "static/media/BusinessDetails.4876d0f0.svg";